import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LectionaryItemTypeEditComponent } from 'app/modules/admin/components/lectionary-item-type-edit/lectionary-item-type-edit.component';
import { LectionaryItemType } from '../../services/lectionary-item-type.service';

@Component({
  selector: 'app-lectionary-item-type-detail',
  templateUrl: './lectionary-item-type-detail.component.html',
  styleUrls: ['./lectionary-item-type-detail.component.css']
})
export class LectionaryItemTypeDetailComponent implements OnInit {

  public item: LectionaryItemType;

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit() {
  }

  public add() {
    const dialogRef = this.dialog.open(LectionaryItemTypeEditComponent, {

      });
  }


}
